// extracted by mini-css-extract-plugin
export default {"select":"UpdateDurationByMonthsField_select__5HnhI"};